import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ButterToast, { Cinnamon } from 'butter-toast'
import { Container } from 'react-bootstrap/lib/Tab'
import { Row, Col } from 'react-bootstrap'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'
import { withRouter, Link } from 'react-router-dom'
import { useStateValue } from '@State'

const HomepageComp = props => {
  const [currentState, dispatch] = useStateValue()
  let contextId = window.location.pathname.split('/')[4]
  useEffect(() => {
    async function resetSelectedLinks() {
      await dispatch({
        type: 'assessmentInclusion',
        payload: [],
      })
      await dispatch({
        type: 'sectionSelection',
        selectedSections: [],
      })
    }
    resetSelectedLinks()
  }, [])
  useEffect(() => {
    async function getHomepageData(contextId, dispatch) {
      try {
        let resp = await client.get(endpoints.getInstructorData({ contextId }))
        await dispatch({
          type: 'updateInstructorData',
          payload: { connectedCourses: resp.data.connectedCourses },
        })
      } catch (err) {
        console.log(err)
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title="Error"
              content={err.response.data.error}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-thumbs-down fa-3x" />}
            />
          ),
        })
      }
    }
    getHomepageData(contextId, dispatch)
  }, [])

  return (
    <React.Fragment>
      <div className="mt-5">
        <div className="d-flex justify-content-between">
          <h1 className="me-page-title">Current Connections</h1>
          <a
            className="btn btn-myed btn-default btn-default-myed info-button mb-0 maxh-40px"
            onClick={() =>
              props.history.push(
                `/links/canvas_connect.instructor_setup/-/${contextId}/connect_resource${window.location.search}`
              )
            }
          >
            <div className="far fa-plus" /> New Connection
          </a>
        </div>
        <Container id="connected-resources">
          <Row xs={2} md={4} lg={6}>
            {currentState.connectedCourses.map((contextCourse, i) => (
              <Col md={9} key={i} className="mx-3 mb-4">
                <div className="card shadow bg-light mb-4">
                  <div className="card-title">
                    <div
                      style={{
                        backgroundImage: `url(/reader/resource/${contextCourse.coursenum}/images/reader-coverpage.jpg)`,
                        backgroundSize: 'cover',
                        maxHeight: '230px',
                        minHeight: '230px',
                      }}
                    />
                  </div>
                  <div className="card-body px-5 pb-5">
                    <h3>{contextCourse.title}</h3>
                    <h5>{`Connected on ${contextCourse.createDate}`}</h5>
                    <i>{`Internal course ${contextCourse.coursenum}`}</i>
                    <div className="d-flex justify-content-between mt-5">
                      <Link
                        to={`/links/canvas_connect.instructor_setup/${contextCourse.coursenum}/${contextId}/configure_assessments${window.location.search}`}
                        className="text-dec-none"
                      >
                        <div className="far fa-bolt mr-2" /> Import Assessments
                      </Link>
                      <Link
                        className="text-dec-none"
                        to={`/links/canvas_connect.instructor_setup/${contextCourse.coursenum}/${contextId}/configure_deep_links${window.location.search}`}
                      >
                        <div className="far fa-bookmark mr-3" />
                        Create Reading Links
                      </Link>
                    </div>
                    <a
                      className="btn btn-myed btn-default btn-default-myed mt-5 btn-block bg-light-gray"
                      href={`/reader/web/${contextCourse.coursenum}/`}
                    >
                      Go to Resource <div className="fas fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
HomepageComp.propTypes = {
  toggle: PropTypes.func,
}
export const Homepage = withRouter(HomepageComp)
